import { clearPersistedPinLock } from "./pin-utils";

export const medecine360SessionTokenKeyName = "medecine360SessionToken";
export const medecine360SessionQueryParamKeyName = "sessionToken";

export const storeQueryParams = () => {
  const urlSearchParam = new URLSearchParams(document.location.search);
  storeMedecine360SessionToken(urlSearchParam);
  removeSearchQueriesFromURL(urlSearchParam);
};

function removeSearchQueriesFromURL(urlSearchParam: URLSearchParams) {
  if (urlSearchParam.size) {
    const urlObj = new URL(window.location.href);
    urlObj.search = "";
    const path = urlObj.toString();
    // Avoid page reload using pushState
    window.history.pushState({ path }, "", path);
  }
}
export const storeMedecine360SessionToken = (
  urlSearchParam: URLSearchParams
) => {
  const medecine360SessionToken = urlSearchParam.get(
    medecine360SessionQueryParamKeyName
  );
  if (medecine360SessionToken) {
    // MED-1643: a fresh login must not open locked because the previous session was. Runs in
    // SessionProvider before PinLockProvider mounts (useIdleLock reads the flag when it mounts);
    // a plain reload of a locked tab has no sessionToken and stays locked.
    clearPersistedPinLock();
    window.sessionStorage.setItem(
      medecine360SessionTokenKeyName,
      medecine360SessionToken
    );
  }
};
export const getMedecine360SessionTokenFromStorage = () => {
  return (
    window.sessionStorage.getItem(medecine360SessionTokenKeyName) ??
    new URLSearchParams(document.location.search).get(
      medecine360SessionQueryParamKeyName
    )
  );
};
export function removeMedecine360SessionTokenFromStorage() {
  if (window.sessionStorage.getItem(medecine360SessionTokenKeyName)) {
    window.sessionStorage.removeItem(medecine360SessionTokenKeyName);
  }
}

export const isTimeExpires = (expiresAt: Date) => {
  const expirationDate = new Date(expiresAt);

  const now = new Date();
  const timeDifference = expirationDate.getTime() - now.getTime();

  const countDown = Math.floor(timeDifference / 1000);
  return countDown < 0;
};

/**
 * Generates a cryptographically secure random password
 * Uses Web Crypto API for secure random number generation
 * @param length - Password length (default: 16)
 * @returns A secure random password string
 */
export const generateTemporaryRandomPassword = (length: number = 16): string => {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*';
  const randomValues = new Uint32Array(length);
  crypto.getRandomValues(randomValues);

  return Array.from(randomValues)
    .map((value) => charset[value % charset.length])
    .join('');
};

/**
 * Validates password strength
 * @param password - Password to validate
 * @returns Object with isValid boolean and error messages
 */
export const validatePasswordStrength = (password: string): {
  isValid: boolean;
  errors: string[]
} => {
  const errors: string[] = [];

  if (password.length < 8) {
    errors.push('Password must be at least 8 characters long');
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter');
  }
  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter');
  }
  if (!/[0-9]/.test(password)) {
    errors.push('Password must contain at least one number');
  }
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
    errors.push('Password must contain at least one special character');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};
